import { render, staticRenderFns } from "./DiscrepancyRemarkRow.vue?vue&type=template&id=11f22900&"
import script from "./DiscrepancyRemarkRow.vue?vue&type=script&lang=js&"
export * from "./DiscrepancyRemarkRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports